import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { selectIsLoading, selectMyProfileData } from 'redux/selectors/auth';
import { editMyProfileData, getMyProfileData } from 'redux/actions/auth';

const mapStateToProps = (state: StateType) => ({
  user: selectMyProfileData(state),
  isLoading: selectIsLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ getMyProfileData, editMyProfileData }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
